import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocationService } from '../../shared/service/location.service';
import { first } from 'rxjs/operators';
import { UrlDecider } from '../../shared/lib/url-decider';

@Component({
  selector: 'app-location-details',
  templateUrl: './location-details.component.html',
  styleUrls: ['./location-details.component.css']
})

export class LocationDetailsComponent implements OnInit {

  lang: any = {};
  langSelector = 'eng';
  locationDetail: any = {};
  visitorInformationToggle:any={safety:false,transactionRequirements:false,metalTheftPolicy:false}

  constructor(private locationService: LocationService, private route: ActivatedRoute) {
    if (UrlDecider.getLangFromUrl()) { this.langSelector = UrlDecider.getLangFromUrl(); }
  }

  ngOnInit() {

    this.loadLanguage();
    const id = this.route.snapshot.paramMap.get('id');
    this.loadLocation(id, this.langSelector);
  }

  loadLocation(locationId: any, language: any) {
    this.locationService.GetLocationDetails(locationId, language).pipe(first()).subscribe((data: any) => {
      this.locationDetail = data;
    });
  }

  loadLanguage() {
    this.locationService.GetLocationDetailsLang(this.langSelector).pipe(first())
      .subscribe((langJson) => {
        this.lang = langJson;
      });
  }

}
